import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useBackendContext } from "../../services/backend/backendContextProvider";
import { useStrokeContext } from "../../services/editor/editorContext";
import { Btn } from "../UI/Btn";
import style from './NameEditor.module.css';

export const NameEditor: React.FC = () => {

    const { t } = useTranslation();

    const { processedBase64, processedNormalized, color, comment, setComment } = useStrokeContext();

    const { submit } = useBackendContext();

    const submitCallback = useCallback(() => {

        if (processedBase64 && processedNormalized && color && comment) {

            submit(
                JSON.stringify(processedNormalized),
                processedBase64,
                color,
                "blue",
                comment
            );

        }

    }, [submit, processedBase64, processedNormalized, color, comment]);

    const maySubmit = !!(processedBase64 && processedNormalized && color && (comment && comment.length > 2));




    return <form className={style.container} onSubmit={e => { e.preventDefault(); if (maySubmit) submitCallback(); }}>

        <input
            type="text"
            placeholder={t("your_nick")}
            value={comment}
            className={style.input}
            onChange={e => setComment(e.target.value)}
        />

        <Btn
            type="submit"
            onClick={submitCallback}
            disabled={!maySubmit}
            area="none"
        >
            {t("send")}
        </Btn>

    </form>;

}